export const WIZARD_DOCPILOT_COOKIE_KEY = 'storydoc_wizard_docpilot_DbGlmuVoG6';